export const SERVICE_FIELDS = [
  "orchid_pro_types",
  "focus_issues",
  "treatment_approaches",
  "clientele_age",
  "clientele_community",
  "modality",
  "services_offered",
  "insurance_accepted",
];

export const PRO_CREDENTIALS_FIELDS = [
  "orchid_pro_types",
  "board_certifications",
  "qualifications",
  "licenses",
  "national_provider_identifier",
  "organization",
];

export const PRO_CREDENTIALS_FIELDS_PROFILE_SETTING = [
  "orchid_pro_types",
  "board_certifications",
  "qualifications",
  "licenses",
  "national_provider_identifier",
  "organization",

  // delete orchid pro needs below fields to exist:
  "undergraduate",
  "graduate",
  "fellowships_json",
  "residency_json",
];

export const EDUCATION_TRAINING_FIELDS = [
  "orchid_pro_types",
  "fellowships_json",
  "residency_json",
  "undergraduate",
  "graduate",
];

// deprecated
export const ABOUT_ME_FIELDS_PROFILE_SETTING = [
  "first_name",
  "last_name",
  "preferred_first_name",
  "name_schema",
  "dob",
  "biography",
  "languages",
  "years_of_practice",
  "links",
  // medical degree is needed for name schema
  "graduate",

  "business_entity_name",
  "org_setting",
  "org_entity_type",
  "organization_national_provider_identifier",
  "tax_id",

  "office_address_line1",
  "office_address_line2",
  "office_city",
  "office_state",
  "office_zipcode",
  "mail_address_line1",
  "mail_address_line2",
  "mail_city",
  "mail_state",
  "mail_zipcode",
  "phone_number",
];

export const ABOUT_ME_PROFILE_SETTING = [
  "first_name",
  "last_name",
  "preferred_first_name",
  "name_schema",
  "dob",
  "biography",
  "languages",
  "years_of_practice",
  "links",
  // medical degree is needed for name schema
  "graduate",
];

export const PRACTICE_SETTING = [
  "business_entity_name",
  "org_setting",
  "org_entity_type",
  "organization_national_provider_identifier",
  "tax_id",

  "office_address_line1",
  "office_address_line2",
  "office_city",
  "office_state",
  "office_zipcode",
  "mail_address_line1",
  "mail_address_line2",
  "mail_city",
  "mail_state",
  "mail_zipcode",
  "phone_number",
  "telehealth_pos_code",
  "in_person_pos_code",
  "telehealth_modifier",
  "in_person_modifier",
  "show_address_to_public",
  "additional_office_locations",
];

export const GET_STARTED_FIELDS = [
  "orchid_pro_types",
  "phone_number",
  "cell_number",
  "office_address_line1",
  "office_address_line2",
  "office_city",
  "office_state",
  "office_zipcode",
  "mail_address_line1",
  "mail_address_line2",
  "mail_city",
  "mail_state",
  "mail_zipcode",
  "business_entity_name",
  "org_setting",
  "org_entity_type",
  "organization_national_provider_identifier",
  "tax_id",
  "licenses",
  "board_certifications",
  "qualifications",
  "undergraduate",
  "graduate",
  "fellowships_json",
  "residency_json",
];

export const ABOUT_ME_FIELDS = [
  "orchid_pro_types",
  "first_name",
  "last_name",
  "preferred_first_name",
  "name_schema",
  "dob",
  "biography",
  "languages",
  "years_of_practice",
  "links",
  // medical degree is needed for name schema
  "graduate",
];

export const CONTRACT_FIELDS = [
  "agreed_to_terms_of_use",
  "confirmed_have_social_security_number_allowed_to_work_in_usa",
  "signature_legal_first_name",
  "signature_legal_last_name",
  "heard_about_orchid_via",
];
